import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const GoalCar: FC<IconSVGComponentProps> = ({ pathProps, ...props }) => {
    return (
        // Override viewBox & strokeWidth, since this is a solid icon
        <IconSVG viewBox="0 0 20 20" strokeWidth={0} {...props}>
            <IconPath
                fill="currentColor"
                fillRule="evenodd"
                d="M10 1.449c-4.716 0-8.55 3.834-8.55 8.55 0 4.716 3.834 8.55 8.55 8.55 4.716 0 8.55-3.834 8.55-8.55 0-4.716-3.834-8.55-8.55-8.55Zm0 13.986a5.431 5.431 0 0 1-5.436-5.436A5.431 5.431 0 0 1 10 4.563 5.431 5.431 0 0 1 15.436 10 5.431 5.431 0 0 1 10 15.435ZM8.22 10.088 5.77 9.297a4.632 4.632 0 0 0-.054.702 4.25 4.25 0 0 0 1.279 3.06l1.511-2.089a1.827 1.827 0 0 1-.287-.882ZM9.37 5.752v2.574a1.937 1.937 0 0 0-.756.539l-2.448-.792A4.316 4.316 0 0 1 9.37 5.751ZM10 11.78c-.162 0-.325-.019-.469-.055L8.02 13.814c.595.306 1.26.486 1.98.486s1.386-.18 1.98-.486l-1.511-2.089a1.94 1.94 0 0 1-.469.055Zm.63-3.454V5.75a4.285 4.285 0 0 1 3.203 2.323l-2.448.792a1.883 1.883 0 0 0-.756-.54Zm.863 2.644 1.512 2.089a4.284 4.284 0 0 0 1.278-3.06c0-.235-.018-.469-.054-.702l-2.448.792c-.018.324-.126.63-.288.881Zm-.539-.97c0 1.271-1.908 1.271-1.908 0 0-1.273 1.908-1.273 1.908 0Z"
                clipRule="evenodd"
                {...pathProps}
            />
        </IconSVG>
    );
};
